export const getQueryString = (param: string, defaultValue?: string): string | undefined => (
  window.location.href.split(`?${param}=`)[1] || defaultValue
);
